import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './Skeleton.css';

export interface SkeletonProps {
    isAnimating: boolean;
    height: number;
    cls?: string;
}

export const Skeleton = React.memo((props: SkeletonProps) => (
    <span
        style={{ height: props.height }}
        className={classNames(
            Bem.cls('skeleton', '', {
                animate: props.isAnimating
            }),
            props.cls
        )}
    />
));
